import React, { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, ColumnProps, Table } from '@digital/ui';
import { DesfazerExclusoesHandOverOrdemCompra, HandOverOrdemCompra, getDocumentosOrdemCompraHandover, updateSasDocumentoOrdemCompraCommand } from '@app/api/sas/sasDocumentoOrdemCompra';
import { Visibility } from '@app/components';
import { useRecoilValue } from 'recoil';
import { dadosGeraisState, ordemCompraIdState } from '../atoms';
import { hasPermission } from '@app/helpers/permissions';
import { isObjEmpty } from '@app/helpers/objHelper';
import { EStatusAprovacaoContrato, EStatusAprovacaoContratoTotvs } from '@app/enums';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

export interface propsModalConfirmarIntegracao {

}

const ModalConfirmarHandover = ({ }: propsModalConfirmarIntegracao) => {
  const ordemCompraId: string = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);

  const [exibirModal, setExibirModal] = useState(false);
  const [exibirBotao, setExibirBotao] = useState(true);
  const [documentos, setDocumentos] = useState<Array<any>>([]);

  const ehAditivoContrato = dadosGerais.tipoContrato && dadosGerais.tipoContrato.toLowerCase() === "contrato" &&  dadosGerais.tipo === ETipoDemanda.Aditivo;
  const aditivoComIntegracaoTotvs = dadosGerais.isPrazo || dadosGerais.isValorSemAcrescimoEscopo;
  const isDisabled = ehAditivoContrato
    ? aditivoComIntegracaoTotvs && (!dadosGerais.contratoEmitido || dadosGerais.statusAprovacaoAditivoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO)
    : !dadosGerais.contratoEmitido || isObjEmpty(dadosGerais.contratoId) || dadosGerais.handover;

  const getDocs = () => {
    getDocumentosOrdemCompraHandover({
      ordemCompraId
    }).then(data => {
      if (data) {
        setDocumentos(data)
      }
    })
  }

  const onChangeHandover = (documentoId: string, handover: boolean) => {
    updateSasDocumentoOrdemCompraCommand({
      sasDocumentoOrdemCompraId: documentoId,
      handover: handover
    }).then(data => {
      if (data) getDocs()
    })
  }

  const onDesfazer = () => {
    DesfazerExclusoesHandOverOrdemCompra(ordemCompraId).then(data => {
      getDocs();
    });
  }

  useEffect(() => {
    exibirModal && getDocs();
  }, [exibirModal])

  const handleConfirm = () => {
    HandOverOrdemCompra(ordemCompraId).then(data => {
      if (data && data.valid) {
        setExibirBotao(false);
      }
    });
    setExibirModal(false);
  };

  const columns = () => {
    let columns: ColumnProps<any>[] = [];

    columns.push({
      title: 'Descrição',
      dataIndex: 'descricao',
    })

    columns.push({
      title: 'Arquivo',
      dataIndex: 'arquivoNomeDownload',
      width: '30%'
    })

    return columns;
  }

  return (
    <>
      <Visibility /*visible={exibirBotao}*/>
        <Tooltip title="Acatar">
          <Button
            className='button-sas-acoes'
            style={{ marginRight: '5px' }}
            type='primary'
            onClick={() => {
              setExibirModal(true);
            }}
            disabled={isDisabled || !exibirBotao || dadosGerais.handover == true}
          >
            Handover
          </Button>
        </Tooltip>
      </Visibility>
      <Modal
        title="Handover"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={<>
          <Visibility visible={false}>
            <Tooltip title="Desfaz todas as exclusões do handover" >
              <Button title='Desfazer' type='link' onClick={() => onDesfazer()} />
            </Tooltip>
          </Visibility>
          <Visibility
            visible={hasPermission(["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"])}
          >
          </Visibility>
          <Button
            title='Fechar'
            type='link'
            onClick={() => setExibirModal(false)}
          />
          <Button title='Confirmar' type='primary' onClick={() =>
            Modal.confirm({
              title: 'Confirmar Handover',
              content:
                'Deseja copiar todos os documentos para o SGC?',
              cancelText: 'Cancelar',
              onCancel: () => setExibirModal(false),
              okText: 'Confirmar',
              onOk: () => {
                handleConfirm();
              },
            })
          } />
        </>}>
        <Table
          dataSource={documentos.ativos}
          columns={columns()}
          pagination={false}
        />
      </Modal>
    </>
  );
};
export default ModalConfirmarHandover;
